// LICENSE_CODE ZON
/*jslint ts:true, react: true*/

// eslint-disable-next-line
export enum Proxy_type {ISP = 'isp', ISPPREM = 'isp_plus',
// eslint-disable-next-line
DDC = 'dedicated_dc', SHARED_ISP = 'shared_isp', SDC = 'shared_dc',
// eslint-disable-next-line
RES = 'smart_resi', EV_ISP = 'events_isp', EV_RES = 'events_resi_tickets',
// eslint-disable-next-line
SNK = 'resi_sneakers',
// eslint-disable-next-line
SCR = 'scraping_browser',
// eslint-disable-next-line
UNKNOWN = 'unknown'};
// eslint-disable-next-line
export type t_proxy_type_map<T> = {[key in Proxy_type]?: T;};

export interface i_row_data {
    id: string;
    token: string;
    create_date: string;
    expiration_date: string;
    is_active: boolean;
    value_columns: string[];
    usage_percent?: number;
    fn: string;
    link: string;
    ips_amount: number;
}
export type t_one_proxy = {
    host: string;
    port: string;
    port_selenium?: string;
    login: string;
    password: string;
    country: string;
    socks5: boolean;
}
export type t_generated_proxy = t_one_proxy & {
    ip: string;
    manually_changed?: boolean;

}
export type t_ip = {
    ip: string;
    country: string;
}
export type t_order_users_state = {
    is_new: boolean;
    expired_seen?: boolean;
    hide_used_extra_limits?: boolean;
}
export interface i_extra_limit {
    limit: number;
    start: string; // "2024-04-10T00:00:00.000Z"
}
export interface i_extra_limit_renewal {
    enable: boolean;
    limit: number;
    update_ts: string;
    errors: string[];
}
export interface i_zone_config {
    premium_domains: boolean;
    captcha_solver: boolean;
    passwords: string[];
    allowed_ips: string[];
    blocked_ips: string[];
    allowed_target_hosts: string[];
    blocked_target_hosts: string[];
    special_ports: boolean;
    custom_headers_and_cookies: boolean;
    post_back_on_start?: string;
    post_back_on_finish?: string;
    post_back_secret?: string;
    post_back_on_step_done?: string;
    usage_limit: {
        limit: number;
        limit_kind: 'usd' | 'gb';
        currency: string;
        period: 'day' | 'month';
        exceed_action: 'alert' | 'suspend_zone' | 'suspend_zone_and_alert';
    }
}
export type t_zone_status = 'started' | 'stopped';
export interface i_zone_task {
    _id: string;
    id_cropped: string;
    url: string;
    description: string;
    text: string;
    status: 'running' | 'finalized' | 'failed' | 'awaiting'
        | 'stopped' | 'unknown';
}
export type t_order = {
    _id: string;
    zone: string;
    name?: string;
    client_id: string;
    subscr_id?: string | null;
    subscription_mode?: boolean;
    subscription_cancelled?: boolean;
    cancelled_manually?: boolean;
    plan_id?: string | null;
    plan_duration?: string;
    renew_error?: string[];
    until: string; // "2024-07-10T00:00:00.000Z"
    start: string; // "2024-04-10T00:00:00.000Z"
    blocking_date?: string;
    blocking_in_hours?: number;
    limit: number;
    type: Proxy_type;
    usage_info?: {used: number;};
    free_zone?: boolean;
    ips_amount?: number;
    enable_additional_usage_charges?: boolean;
    ips_whitelist?: string[];
    unit?: 'ip' | 'gb';
    generated_proxies?: t_generated_proxy[];
    subscription_until?: string;
    user_state?: t_order_users_state,
    prev_usage?: {
        used: number;
        limit: number;
    };
    plan_limit?: number;
    additional_limit?: number;
    next_zone_id?: string;
    group_id?: string;
    is_legacy?: boolean;
    plan_price?: number;
    expired_recently?: boolean;
    extra_limits?: i_extra_limit[];
    extra_limit_renewal?: i_extra_limit_renewal;
    allowed_bw_renewal?: boolean;
    auth_type?: 'ip' | 'user';
    disabled?: {
        ts: string;
        reason: string;
        source: string;
    };
    rotated_by_user_ts?: string;
    status?: t_zone_status;
    config?: i_zone_config;
    tasks?: i_zone_task[];
    refund_product_id?: string;
};

export type t_orders = {
    dedicated_dc: t_order[];
    isp: t_order[];
    shared_dc: t_order[];
    shared_isp: t_order[];
    isp_plus: t_order[];
    smart_resi: t_order[];
};

export type t_zone_group = {
    _id: string;
    subscr_id?: string | null;
    subscription_cancelled?: boolean;
    plan_id?: string | null;
    name?: string;
    type: string;
    start: string;
    until: string;
    limit: number;
    usage_info?: {used: number;};
    unit?: 'ip' | 'gb';
    subscription_until?: string;
    user_state?: t_order_users_state;
    enable_additional_usage_charges: boolean;
    zones: t_order[];
    next_group_id?: string;
    allowed_bw_renewal?: boolean;
    free_group?: boolean;
    prev_usage?: {
        used: number;
        limit: number;
    };
    extra_limits?: i_extra_limit[];
    extra_limit_renewal?: i_extra_limit_renewal;
}

type t_cart_item = {
    plan: {
        id: Proxy_type
    },
    quantity: string; // "25"
    country: string; // "us" | "il"
};

export type t_payment = {
    ccard_country: string;
    ccard_exp_month: number;
    name: string;
    ccard_exp_year: number;
    ccard_lbl: string;
    ccard_last4: string;
    ccard_type: string;
    cart?: t_cart_item[];
};

export type t_payment_method = {
    id: string;
    card_country: string;
    card_exp_lbl: string;
    card_last4: string;
    card_lbl: string;
    card_type: string;
    error?: string
};

export type t_user_info = {
    email: string;
    first_name: string;
    last_name: string;
    ip: string;
};

export type t_account = {
    user_info: t_user_info;
    last_payment?: t_payment;
    payment_methods?: t_payment_method[];
};
